import type { FaireProductEntity } from "../../entity_types/product";

export const p_d2ga3wmz6f: FaireProductEntity = {
  token: "p_d2ga3wmz6f",
  type: "product",
  name: "Oversized Lapel Collar Knitted Cardigan",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/dc9a3da4f551d32a7fab8a7ffb0279ab36c119123f8d06984fdf30c8f355b953.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9cecd8a8f23731350e51c10ef11acced0be873cb001744d874ada36a4a5ce11.jpeg",
    "https://cdn.faire.com/fastly/4b865234a16dcb5ba81391f55e1465bc3f156cff720b6466fb92bd9af87406e1.jpeg",
    "https://cdn.faire.com/fastly/fd3157ae0f55e91c36b140841f5c1586dd9391e2fa1ab371d7d25d90b9581635.jpeg",
    "https://cdn.faire.com/fastly/7bcde350d701cf712c9d788d3898c0b70bba21b4d6db507ee44d2586f267b96a.jpeg",
    "https://cdn.faire.com/fastly/3c5c58be985561ab08ad53c46220cd362673ce0c3678080a51e2c9b638c3f273.jpeg",
    "https://cdn.faire.com/fastly/e6bf3ea1abf41478a4b52c4f0d2db2a913ddca4c346473cd4760b80caa677ffe.jpeg",
    "https://cdn.faire.com/fastly/c9ce6092bdc5fa7431734e7b1e4aa2c9a4c31b4aa4ce6788cd99dfdf0871b632.jpeg",
    "https://cdn.faire.com/fastly/15c9f446519f33ba94e9ea760c84775b550dcefeea313708e3fdd8cb77d5e06f.jpeg",
    "https://cdn.faire.com/fastly/b0c93d92056f6f6d91ba83adb12315ae63c8813c1b597d311d48f4e04225712e.jpeg",
  ],
  priceDollars: 35.95,
  description:
    "OVERSIZED LAPEL COLLAR KNITTED CARDIGAN_RCJW03701\n\nSize Chart(Inch)\t\t\t\n\t Chest\tLength\tSleeve  \nS\t 45.67 \t 32.28 \t 19.69 \nM\t 47.24 \t 32.68 \t 20.08 \nL\t 48.82 \t 33.07 \t 20.47 \nXL\t 51.18 \t 33.46 \t 20.87 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2026 Women Apparel",
  tags: [],
  msrpDollars: 71.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:24.587Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
